// Utility functions for formatting status values across the application

export const formatStatus = (status: string): string => {
  const statusMap: { [key: string]: string } = {
    // Vehicle statuses
    in_stock: 'Em Estoque',
    sold: 'Vendido',
    reserved: 'Reservado',

    // Asset statuses
    active: 'Ativo',
    inactive: 'Inativo',
    exchanged: 'Permutado',
    rented: 'Ativo',
    terminated: 'Encerrado',

    // Debt statuses
    paid: 'Pago',
    overdue: 'Em Atraso',
    renegotiated: 'Renegociado',

    // User statuses
    available: 'Disponível',

    // Default fallbacks
    pending: 'Pendente',
    cancelled: 'Cancelado',
    completed: 'Concluído',
  };

  return statusMap[status] || status;
};

export const getStatusColor = (status: string): string => {
  const colorMap: { [key: string]: string } = {
    // Green - positive/active states
    in_stock: 'bg-green-100 text-green-800',
    active: 'bg-green-100 text-green-800',
    available: 'bg-green-100 text-green-800',
    paid: 'bg-green-100 text-green-800',
    completed: 'bg-green-100 text-green-800',

    // Red - negative/inactive states
    sold: 'bg-red-100 text-red-800',
    inactive: 'bg-red-100 text-red-800',
    overdue: 'bg-red-100 text-red-800',
    cancelled: 'bg-red-100 text-red-800',

    // Yellow - warning/pending states
    reserved: 'bg-yellow-100 text-yellow-800',
    pending: 'bg-yellow-100 text-yellow-800',
    renegotiated: 'bg-yellow-100 text-yellow-800',

    // Blue - neutral/info states
    exchanged: 'bg-blue-100 text-blue-800',
    rented: 'bg-green-100 text-green-800',
    terminated: 'bg-gray-100 text-gray-800',

    // Default gray
    default: 'bg-gray-100 text-gray-800',
  };

  return colorMap[status] || colorMap.default;
};
